export default function SelectView(state, payload){
    const {key} = payload
    const selectedCollections = {}
    const selectedProducts = {}
    const selectedSpecialConditions = {}
    state.currentView = key

    return {...state, selectedCollections, selectedProducts, selectedSpecialConditions} 
}